module.exports = __webpack_public_path__ + "img/c-en-26.bdfac7f5.png";